import { Helmet } from 'react-helmet-async';

import { Stack } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import ApplicationsList from 'src/sections/applications/table/applications-list';

// ----------------------------------------------------------------------

export default function ApplicationsPage() {
  const settings = useSettingsContext();

  const { t } = useTranslate();

  return (
    <>
      <Helmet>
        <title>Dashboard: Applications</title>
      </Helmet>

      <Container
        maxWidth={settings.themeStretch ? false : 'lg'}
        sx={{
          height: 1,
        }}
      >
        <Stack spacing={2}>
          <CustomBreadcrumbs
            heading={t('applications.list_title', { defaultValue: 'Applications' })}
            links={[
              { name: t('common.dashboard'), href: paths.dashboard.root },
              {
                name: t('applications.list_title', { defaultValue: 'Applications' }),
                href: paths.dashboard.applications.root,
              },
            ]}
          />
          <ApplicationsList />
        </Stack>
      </Container>
    </>
  );
}
